/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IGenericMultipleModalResultsMap {
        [name: string]: string;
    }

    export interface IGenericMultipleModalInputsMap {
        [name: string]: IGenericModalInput;
    }
    export interface IGenericModalInput {
        required: boolean;
        value: string;
    }

    export interface IGenericMultipleModalScope extends ng.IScope {
        title: string;
        description: string;
        inputs: IGenericMultipleModalInputsMap;

        keys: string[]
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * GenericMultipleModalController class
     */
    export class GenericMultipleModalController {
        public static templateUrl: string = "decorators/modals/generic-multiple-modal.html";
        public static id: string = "#id-generic-multiple-modal";
        public static $name: string = "genericMultipleModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           '$timeout',
                                           'title',
                                           'description',
                                           'inputs',];

        private $scope: IGenericMultipleModalScope;
        private close: (parameters: IGenericMultipleModalResultsMap) => void;

        /**
         * Constructor
         */
        constructor($scope: IGenericMultipleModalScope,
                    close: (parameters: IGenericMultipleModalResultsMap) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    description: string,
                    inputs: IGenericMultipleModalInputsMap) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.$scope.title = title;
            this.$scope.description = description;
            this.$scope.inputs = inputs;
            this.$scope.keys = Object.keys(this.$scope.inputs)

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                let answers: IGenericMultipleModalResultsMap = {};
                let allRequired: boolean = true;
                this.$scope.keys.forEach((inputName: string) => {
                    if (this.$scope.inputs[inputName].required) {
                        if (this.$scope.inputs[inputName].value) {
                            answers[inputName] = this.$scope.inputs[inputName].value;
                        } else {
                            allRequired = false;
                        }
                    } else {
                        answers[inputName] = this.$scope.inputs[inputName].value;
                    }
                })
                if (allRequired) {
                    this.close(answers);
                }
            };
        }
    }
}
